function PolicyParagraphs({ paragraphs }) {
  return (
    <div className="policy-body">
      {paragraphs.map((paragraph) => (
        <p key={paragraph}>{paragraph}</p>
      ))}
    </div>
  );
}

export function PolicyDocument({ document }) {
  return (
    <>
      <div className="policy-intro">
        <p className="eyebrow">UNITED AUTOSPORTS TRACKSIDE APP</p>
        <h1>{document.title}</h1>
        {document.intro.map((paragraph) => (
          <p key={paragraph} className="lead">
            {paragraph}
          </p>
        ))}
        <p className="updated">{document.version}</p>
      </div>

      <div className="policy-sections">
        {document.sections.map((section) => (
          <section key={section.title}>
            <h2>{section.title}</h2>
            <PolicyParagraphs paragraphs={section.paragraphs} />
          </section>
        ))}
      </div>
    </>
  );
}
